import { useState, useEffect } from "react";
import {
  Autocomplete,
  FormControl,
  TextField,
  Grid,
  Card,
  CardContent,
  Switch,
  Select,
  MenuItem,
  Chip,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "../../../../components";
import { InputErros, value } from "../../../../helpers";
import { OperacaoFiscalService } from "../../../../services";
import { responseErros } from "../../../../utils";
import "../../configuracoes.style.css";

const ConfiguracaoVendaTab = ({
  configuracao,
  onChangeAutocomplete,
  onChangeSwitch,
  onChange,
  dadosEmpresa,
}) => {
  const operacaoFiscalService = new OperacaoFiscalService();
  const [inputErro, setInputErro] = useState([]);
  const [operacaoFiscalVendaList, setOperacaoFiscalVendaList] = useState([]);
  const [operacaoFiscalMdfeList, setOperacaoMdfeFiscalList] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const flagsVendaItem = [
    {
      label: "Desconto",
      key: "descontoVendaItem",
    },
    {
      label: "Despesa",
      key: "despesaVendaItem",
    },
    {
      label: "Frete",
      key: "freteVendaItem",
    },
  ];

  useEffect(() => {
    buscarOperacoesFiscais();
  }, []);

  function separarOperacoesFiscais(operacoesFiscais) {
    const operacaoFiscalMdfe = [];
    const operacaoFiscalVenda = [];
    operacoesFiscais.forEach((operacaoFiscal) => {
      if (operacaoFiscal.modeloDocumento == "58") {
        operacaoFiscalMdfe.push(operacaoFiscal);
      } else {
        operacaoFiscalVenda.push(operacaoFiscal);
      }
    });
    setOperacaoFiscalVendaList(operacaoFiscalVenda);
    setOperacaoMdfeFiscalList(operacaoFiscalMdfe);
  }

  const buscarOperacoesFiscais = () => {
    const filtros = {
      ativado: true,
      restritiva: true,
      tipoOperacao: "SAIDA",
    };
    operacaoFiscalService.getAllFiltroAvancado(filtros).then((result) => {
      if (!result.isAxiosError) {
        separarOperacoesFiscais(result.data.rows);
      } else {
        responseErros(result);
      }
    });
  };

  const handleSelecaoFlag = (flagKey) => {
    const event = {
      target: {
        name: flagKey,
        value: !configuracao[flagKey],
        type: "checkbox",
        checked: !configuracao[flagKey],
      },
    };
    onChange(event);
  };

  const handleChangeInicialCodigoBarras = (event) => {
    const input = event.target.value;
    if (input === "" || /^[0-9]$/.test(input)) {
      onChange(event);
    }
  };

  return (
    <Card className="p-2">
      <CardContent>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN001 - Operação fiscal padrão.
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="operacaoFiscalVendasPadraoId"
                name="operacaoFiscalVendasPadraoId"
                options={operacaoFiscalVendaList}
                noOptionsText="Sem opções"
                autoHighlight
                disableClearable
                getOptionLabel={(option) => (option ? option.descricao : "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Operação Fiscal"
                    variant="outlined"
                    error={inputErros.get("operacaoFiscalVendasPadraoId")}
                  />
                )}
                onChange={(_, newValue) => {
                  setInputErro([]);
                  onChangeAutocomplete(
                    "operacaoFiscalVendasPadraoId",
                    newValue,
                  );
                }}
                value={value.autoComplete(
                  operacaoFiscalVendaList,
                  configuracao?.operacaoFiscalVendasPadraoId,
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN002 - Permitir a venda de produtos com estoque negativo.
          </Grid>
          <Grid item xs={4}>
            <Switch
              id="vendaEstoqueNegativo"
              name="vendaEstoqueNegativo"
              checked={
                configuracao?.vendaEstoqueNegativo
                  ? configuracao?.vendaEstoqueNegativo
                  : false
              }
              onChange={onChangeSwitch}
              color="primary"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN003 - Visualizar impressão ao emitir nota.
          </Grid>
          <Grid item xs={4}>
            <Switch
              id="visualizarImpressaoEmissao"
              name="visualizarImpressaoEmissao"
              checked={
                configuracao?.visualizarImpressaoEmissao
                  ? configuracao?.visualizarImpressaoEmissao
                  : false
              }
              onChange={onChangeSwitch}
              color="primary"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN004 - Dias para vencimento de Orçamento.
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="diasVencimentoOrcamento"
              name="diasVencimentoOrcamento"
              label="Quantidade Dias"
              type="number"
              variant="outlined"
              margin="normal"
              inputProps={{ min: 0 }}
              value={configuracao?.diasVencimentoOrcamento ?? 0}
              onChange={onChange}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN005 - Quando o cliente possuir Limite de Crédito Ultrapassado.
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Limite de Crédito"
              id="limiteCredito"
              name="limiteCredito"
              margin="normal"
              value={value.text(configuracao.limiteCredito)}
              disableClearable
              onChange={onChange}
            >
              <MenuItem value={"PROSSEGUIR"}>Não avisar</MenuItem>
              <MenuItem value={"AVISAR"}>Apenas avisar</MenuItem>
              <MenuItem value={"BLOQUEAR"}>Bloquear Operação</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN006 - Quando o cliente estiver Inadimplente.
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Inadimplencia"
              id="inadimplencia"
              name="inadimplencia"
              margin="normal"
              value={value.text(configuracao.inadimplencia)}
              disableClearable
              onChange={onChange}
            >
              <MenuItem value={"PROSSEGUIR"}>Não Avisar</MenuItem>
              <MenuItem value={"AVISAR"}>Apenas Avisar</MenuItem>
              <MenuItem value={"BLOQUEAR"}>Bloquear Operação</MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN007 - Na venda, o campo de meio de pagamento é obrigatório.
          </Grid>
          <Grid item xs={4}>
            <Switch
              id="obrigatoriedadeMeioPagamento"
              name="obrigatoriedadeMeioPagamento"
              checked={
                configuracao?.obrigatoriedadeMeioPagamento
                  ? configuracao?.obrigatoriedadeMeioPagamento
                  : false
              }
              onChange={onChangeSwitch}
              color="primary"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN008 - Configurar campos de desconto, despesa e frete nos itens de
            venda.
          </Grid>
          <Grid item xs={4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                justifyContent: "flex-center",
                alignItems: "center",
              }}
            >
              {flagsVendaItem.map((flag) => (
                <Chip
                  key={flag.key}
                  label={flag.label}
                  clickable
                  onClick={() => handleSelecaoFlag(flag.key)}
                  color={configuracao?.[flag.key] ? "primary" : "default"}
                  variant={configuracao?.[flag.key] ? "filled" : "outlined"}
                  sx={{
                    fontSize: {
                      xs: "0.7rem",
                      sm: "0.75rem",
                      md: "0.8125rem",
                    },
                    height: {
                      xs: 28,
                      sm: 32,
                      md: 36,
                    },
                    minWidth: {
                      xs: 70,
                      sm: 85,
                      md: 95,
                    },
                    "& .MuiChip-label": {
                      px: 1,
                      whiteSpace: "nowrap",
                    },
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "translateY(-1px)",
                      boxShadow: 1,
                    },
                    ...(configuracao?.[flag.key] && {
                      boxShadow: 1,
                      fontWeight: 500,
                    }),
                  }}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN009 - Na venda, a busca de produtos é efetuada apenas por código
            de barras.
          </Grid>
          <Grid item xs={4}>
            <Switch
              id="buscaProdutosCodigoBarras"
              name="buscaProdutosCodigoBarras"
              checked={
                configuracao?.buscaProdutosCodigoBarras
                  ? configuracao?.buscaProdutosCodigoBarras
                  : false
              }
              onChange={onChangeSwitch}
              color="primary"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN010 - Operação fiscal MDF-e padrão.
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="operacaoFiscalMdfePadraoId"
                name="operacaoFiscalMdfePadraoId"
                options={operacaoFiscalMdfeList}
                noOptionsText="Sem opções"
                autoHighlight
                disableClearable
                getOptionLabel={(option) => (option ? option.descricao : "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Operação Fiscal"
                    variant="outlined"
                    error={inputErros.get("operacaoFiscalMdfePadraoId")}
                  />
                )}
                onChange={(_, newValue) => {
                  setInputErro([]);
                  onChangeAutocomplete("operacaoFiscalMdfePadraoId", newValue);
                }}
                value={value.autoComplete(
                  operacaoFiscalMdfeList,
                  configuracao?.operacaoFiscalMdfePadraoId,
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN011 - Número inicial para códigos de barras para balanças.
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="inicialCodigoBarrasBalanca"
              name="inicialCodigoBarrasBalanca"
              label="Inicial"
              type="number"
              variant="outlined"
              margin="normal"
              value={configuracao?.inicialCodigoBarrasBalanca}
              onChange={(event) => handleChangeInicialCodigoBarras(event)}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN012 - Leitura padrão da balança.
          </Grid>
          <Grid item xs={4}>
            <RadioGroup
              aria-labelledby="leituraPadraoBalanca"
              name="leituraPadraoBalanca"
              value={configuracao?.leituraPadraoBalanca ?? ""}
              onChange={onChange}
              row
            >
              <FormControlLabel
                value="PESO"
                control={<Radio />}
                label="PESO"
                sx={{ mr: 5 }}
              />
              <FormControlLabel
                value="QUANTIDADE"
                control={<Radio />}
                label="PREÇO"
              />
            </RadioGroup>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN013 - Modalidade calculo de comissão.
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Modalidade de Comissão"
              id="modalidadeComissao"
              name="modalidadeComissao"
              margin="normal"
              value={value.text(configuracao.modalidadeComissao)}
              disableClearable
              onChange={onChange}
            >
              <MenuItem value={"FATURAMENTO"}>Por faturamento</MenuItem>
              <MenuItem value={"FINANCEIRO"}>Por Recebimento</MenuItem>
              <MenuItem value={"PRODUTO"}>Por Produto</MenuItem>
            </Select>
          </Grid>
        </Grid>
        {dadosEmpresa.moduloBoleto && <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            VEN014 - Enviar boletos após emissão
          </Grid>
          <Grid item xs={4}>
            <Switch
              id="enviarBoletoAposEmissao"
              name="enviarBoletoAposEmissao"
              checked={
                configuracao?.enviarBoletoAposEmissao
                  ? configuracao?.enviarBoletoAposEmissao
                  : false
              }
              onChange={onChangeSwitch}
              color="primary"
            />
          </Grid>
        </Grid>}
      </CardContent>
    </Card>
  );
};

export default ConfiguracaoVendaTab;
